import { Fragment, FunctionComponent, memo, useContext, useLayoutEffect } from 'react';
import { RightSideContext } from '../../context';
import { useIsNarrowViewport } from '../../shared';
import { Disruption } from './Disruption';
import { EventsCalendar } from './EventsCalendar';
import { ExternalLinks } from './ExternalLinks';
import { ExternalTagsList } from './ExternalTagsList';
import { FeaturedCards } from './FeaturedCards';
import { LatestsStoryCards } from './LatestsStoryCards';
import { UpcomingEvents } from './UpcomingEvents';
import { useRightSideWidgets, Widget, WidgetType } from './useRightSideWidgets';

import classNames from 'classnames';
import classes from './RightSide.module.scss';

const renderWidget = (widget: Widget) => {
  switch (widget.type) {
    case WidgetType.EXTERNAL_TAGS_LIST:
      return <ExternalTagsList />;
    case WidgetType.EVENTS_CALENDAR:
      return <EventsCalendar config={widget.config} />;
    case WidgetType.LATEST_STORY_CARDS:
      return <LatestsStoryCards config={widget.config} />;
    case WidgetType.EXTERNAL_LINKS:
      return <ExternalLinks config={widget.config} />;
    case WidgetType.FEATURED_CARDS:
      return <FeaturedCards config={widget.config} />;
    case WidgetType.DISRUPTION:
      return <Disruption config={widget.config} />;
    case WidgetType.UPCOMING_EVENTS:
      return <UpcomingEvents config={widget.config} />;
  }
};

export const RightSide: FunctionComponent = memo(() => {
  const { setIsRightSideEmpty } = useContext(RightSideContext);

  const isNarrowViewport = useIsNarrowViewport();

  const widgets = useRightSideWidgets();

  useLayoutEffect(() => {
    setIsRightSideEmpty(!widgets.length);
  }, [setIsRightSideEmpty, widgets.length]);

  if (!widgets.length) {
    return null;
  }

  return (
    <aside
      className={classNames(classes['right-side'], {
        [classes['right-side--panel']]: isNarrowViewport,
      })}
    >
      {widgets.map((widget, index) => (
        <Fragment key={index}>{renderWidget(widget)}</Fragment>
      ))}
    </aside>
  );
});
